import React from 'react';
import RouteHandler from './components/routeHandler';

const App = () => (
  <main>
    <RouteHandler />
  </main>
);

export default App;
